// src/router/Router.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import Login from "../auth/Login";
import Dashboard from "../pages/Dashboard";
import AddLead from "../pages/AddLead";
import Leads from "../pages/Leads";
import Companies from "../pages/Companies";
import Reports from "../pages/Reports";
import Settings from "../pages/Settings";
import Profile from "../pages/Profile";
import ManageUsers from "../pages/ManageUsers";
import UserRegistration from "../pages/users/UserRegistration";
import AddCompanyForNewUser from "../pages/AddCompanyForNewUser";
import LeadDetails from "../pages/LeadDetails";
import AllLeads from "../pages/AllLeads";
import NotificationScreen from "../pages/Notification";
import CalendarView from "../pages/CalendarView";
// Import the Material-UI version of NotAddedByAdmin
import NotAddedByAdmin from "../components/NotAddedByAdmin"; // Make sure this path is correct
import MeetingsScreen from '../pages/MeetingsScreen';
import QuotationsScreen from '../pages/QuotationsScreen';
import TeamCollaboration from "../pages/TeamCollaboration";
import TeamCollaborationDetail from "../pages/TeamCollaborationDetail";
function isUserProfileIncomplete(userData) {
  return !userData?.name || !userData?.phone;
}

const AppRouter = ({ userData }) => {
  const { currentUser } = useAuth();

  // Helper function to render protected routes with user data
  const renderProtectedRoute = (Component, requiresCompleteProfile = true) => {
    if (!currentUser) return <Navigate to="/login" />;
    
    if (!userData) return <NotAddedByAdmin email={currentUser.email} />;
    
    if (requiresCompleteProfile && isUserProfileIncomplete(userData)) {
      return <UserRegistration userData={userData} />;
    }
    
    return <Component userData={userData} />;
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={currentUser ? <Navigate to="/dashboard" /> : <Login />}
      />
      
      <Route
        path="/dashboard"
        element={renderProtectedRoute(Dashboard)}
      />
      
      <Route
        path="/add-lead"
        element={renderProtectedRoute(AddLead)}
      />
      
      <Route
        path="/leads"
        element={renderProtectedRoute(Leads)}
      />
      
      <Route 
        path="/lead/:leadId" 
        element={currentUser ? <LeadDetails userData={userData} /> : <Navigate to="/login" />}
      />
      
      <Route
        path="/add-company"
        element={renderProtectedRoute(Companies)}
      />
      
      <Route
        path="/all-leads"
        element={renderProtectedRoute(AllLeads)}
      />
      
      <Route
        path="/reports"
        element={renderProtectedRoute(Reports)}
      />

      <Route path="/notifications" element={renderProtectedRoute(NotificationScreen)}/>
      
      <Route
        path="/settings"
        element={renderProtectedRoute(Settings)}
      />
      
      <Route
        path="/profile"
        element={renderProtectedRoute(Profile, false)}
      />
      
      <Route
        path="/manage-users"
        element={renderProtectedRoute(ManageUsers)}
      />
      <Route
      path="/calendar"
      element={renderProtectedRoute(CalendarView)}
      />
      <Route
      path="/meetings"
      element={renderProtectedRoute(MeetingsScreen)}
      />

      <Route
      path="/quotations"
      element={renderProtectedRoute(QuotationsScreen)}
      />
       <Route
        path="/team-collaboration"
        element={renderProtectedRoute(TeamCollaboration)}
      />
      
      <Route
        path="/team-collaboration/:collaborationId"
        element={renderProtectedRoute(TeamCollaborationDetail)}
      />
      <Route
        path="/"
        element={<Navigate to={currentUser ? "/dashboard" : "/login"} />}
      />
    </Routes>
  );
};

export default AppRouter;